module.exports = __webpack_public_path__ + "static/media/main-logo.4d84542a.svg";